module.exports = __webpack_public_path__ + "img/BAWS_Dagger1_3_5.25efefc4.png";